<template>
  <div class="teasMbModulePoint">
    <div class="pointTitle" v-if="dataItem._level == 2">
      <span>
        <label>{{ dataItem.title }}</label>
      </span>
    </div>
    <div v-else class="defaultTitle">
      <div class="underdashed"></div>
      <div>{{ dataItem.title }}</div>
    </div>
    <div
      class="firstTypeOne-children-secondItem-list"
      :class="
        dataItem.children && dataItem.children.length > 0 ? 'hasLeftBorder' : ''
      "
      :style="{ paddingTop: (dataItem._level != 2 ? '20' : '10') + 'px' }"
    >
      <div
        class="firstTypeOne-children-secondItem-list-content"
        :style="{ paddingTop: (dataItem.list.length == 0 ? '0' : '13') + 'px' }"
      >
        <div
          class="
            firstTypeOne-children-secondItem-list-content-item
            list-item-grow
          "
          v-for="(secondList, secondListIndex) in dataItem.list"
          :key="secondListIndex"
          :class="{
            noRightBorder:
              (dataItem.list.length < 3 &&
                secondListIndex % dataItem.list.length == dataItem.list.length - 1 && dataItem.is_total_value != '1') ||
              secondListIndex % 3 == 2,
            'threeItem-list-more': dataItem.list.length >= 4,
          }"
          @click="clickItem(secondList)"
        >
          <div class="score">{{ secondList.score }}</div>
          <div class="title">{{ secondList.title }}</div>
        </div>
        <div
          class="list-item-grow list-item-total"
          v-if="dataItem.is_total_value == '1'"
        >
          <div class="item-total">
            <span class="totalTitle">{{ dataItem.totalItem.title }}:</span>
            <span class="second-score">
              <span class="score">{{ dataItem.totalItem.score }}</span>
              <span class="detail"></span>
            </span>
            <span class="text">分</span>
          </div>
        </div>
      </div>
    </div>
    <div
      class="pointChildren"
      v-if="dataItem.children && dataItem.children.length > 0"
    >
      <DsfMobileTeasMbDbPointModule
        v-for="(item, index) in dataItem.children"
        :key="index"
        :dataItem="item"
        :class="index != (dataItem.children.length - 1) ? 'hasLeftBorder' : ''"
        @moduleClickItem="moduleClickItem"
      ></DsfMobileTeasMbDbPointModule>
    </div>
  </div>
</template>

<script>
export default {
  name: "DsfMobileTeasMbDbPointModule",
  ctrlCaption: "",
  mixins: [$mixins.control],
  components: {},
  design: {
    isMask: false,
  },
  props: {
    dataItem: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  created() {
  },
  methods: {
    clickItem(item) {
      this.$emit('moduleClickItem', item)
    },
    moduleClickItem(item) {
      this.$emit('moduleClickItem', item)
    }
  },
};
</script>

<style>
</style>